module.exports = __webpack_public_path__ + "img/expand_64.ac56013f.svg";